document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".custom-banner-slider", {
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
    });
  new Swiper(".brand-slider", {
      loop: true,
      slidesPerView: 1,
    a11y: false,
      spaceBetween: 0,
      navigation: {
        nextEl: ".brand-slider .swiper-button-next",
        prevEl: ".brand-slider .swiper-button-prev",
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        575: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
        1280: { slidesPerView: 5 }
      }
    });
  new Swiper(".custom_featured_collection", {
      loop: true,
    a11y: false,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: ".custom_featured_collection .swiper-button-next",
        prevEl: ".custom_featured_collection .swiper-button-prev",
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        575: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
        1280: { slidesPerView: 5 }
      }
    });
  new Swiper(".popcat_cover", {
      loop: true,
      slidesPerView: 1,
    a11y: false,
      spaceBetween: 0,
      navigation: {
        nextEl: ".popcat_cover .swiper-button-next",
        prevEl: ".popcat_cover .swiper-button-prev",
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        575: { slidesPerView: 2 },
        991: { slidesPerView: 3 }
      }
    });
  
    initializeRelatedProductsSwiper();
  });
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".related-products-slider .swiper-wrapper");
  if (container && container.children.length > 0) {
    initializeRelatedProductsSwiper();
  }
});

// Related Product Slider (Swiper version)
function initializeRelatedProductsSwiper() {
  const container = document.querySelector(".related-products-slider");

  // Only initialize if the slider exists and isn't already initialized
  if (!container || container.classList.contains("swiper-initialized")) return;

  new Swiper(".related-products-slider", {
    loop: true,
    a11y: false,
    slidesPerView: 1,
    spaceBetween: 0,
    centerMode: false,
    centeredSlides:false,
    navigation: {
      nextEl: ".related-products-slider .swiper-button-next",
      prevEl: ".related-products-slider .swiper-button-prev",
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
     575: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
      1280: { slidesPerView: 5 }
    }
  });

  // Mark as initialized
  container.classList.add("swiper-initialized");
}

// Check periodically if the related-products-slider content has loaded
const checkRelatedProductsInterval = setInterval(function () {
  const container = document.querySelector(".related-products-slider .swiper-wrapper");
  if (container && container.children.length > 0) {
    initializeRelatedProductsSwiper();
    clearInterval(checkRelatedProductsInterval);
  }
}, 100); // Check every 100ms


// Show the second element with class "main-banner"
const mainBanner = document.querySelectorAll('.main-banner')[1];
if (mainBanner) {
  mainBanner.style.display = 'block';
}

// Show the second element with class "popcat-section"
const popcatSection = document.querySelectorAll('.popcat-section')[1];
if (popcatSection) {
  popcatSection.style.display = 'block';
}

// Show the second element with class "brand_logo"
const brandLogo = document.querySelectorAll('.brand_logo')[1];
if (brandLogo) {
  brandLogo.style.display = 'block';
}

// Show all submenu wrappers inside hover-menu
document.addEventListener("DOMContentLoaded", function () {
  const submenus = document.querySelectorAll(".hover-menu .submenu_wrapper");
  submenus.forEach(submenu => {
    submenu.style.display = "block";
  });
});

